import Vue from 'vue'
import Router from 'vue-router'
import VueResource from 'vue-resource';
import Index from '@/components/Index'
import Introduction from '@/components/Introduction'
import IntroductionList from '@/components/IntroductionList'
import NewsInfo from '@/components/NewsInfo'
import NewsList from '@/components/NewsList'
import NewsList2 from '@/components/NewsList2'
import MaintainPage from '@/components/MaintainPage'
import Authentication from '@/components/Authentication'
import Speech from '@/components/Speech'
import MemberService from '@/components/MemberService'
import Constitution from '@/components/Constitution'
import Notice from '@/components/Notice'
import NoticeList from '@/components/NoticeList'
import ContactUs from '@/components/ContactUs'
import NotFound from '@/components/NotFound'
import GroupList from '@/components/GroupList'

Vue.use(Router)
Vue.use(VueResource);
export default new Router({
	/*mode:'history',*/
	routes: [
	{ //首页
		path: '/',
		name: 'Index',
		component: Index
	},
	{ //协会简介
		path: '/Introduction',
		name: 'Introduction',
		component: Introduction
	},
	{ //关于协会
		path: '/IntroductionList',
		name: 'IntroductionList',
		component: IntroductionList
	},
	{ //协会文章详情
		path: '/NewsInfo/:id',
		name: 'NewsInfo',
		component: NewsInfo
	},
	{ //协会文章列表
		path: '/NewsList/:id',
		name: 'NewsList',
		component: NewsList
	},
	{ //协会文章列表
		path: '/NewsList2/:id',
		name: 'NewsList2',
		component: NewsList2
	},
	{ //认证页面
		path: '/Authentication',
		name: 'Authentication',
		component: Authentication
	},	
	{ //维护中页面
		path: '/MaintainPage',
		name: 'MaintainPage',
		component: MaintainPage
	},
	{ //会长致辞
		path: '/Speech',
		name: 'Speech',
		component: Speech
	},
		{ //会员服务
		path: '/MemberService',
		name: 'MemberService',
		component: MemberService
	},
	{ //通知公告
		path: '/Notice',
		name: 'Notice',
		component: Notice
	},
	{ //通知公告
		path: '/NoticeList',
		name: 'NoticeList',
		component: NoticeList
	},
	{ //团体标准
	path: '/GroupList',
	name: 'GroupList',
	component: GroupList
	},
	{ //章程公示
		path: '/Constitution',
		name: 'Constitution',
		component: Constitution
	},
	{ //联系我们
		path: '/ContactUs',
		name: 'ContactUs',
		component: ContactUs
	},
	{ //404
		path: '/NotFound',
		name: 'NotFound',
		component: NotFound
	},
	{ //404 页面 必须放到最后一个
		path: '*',
		redirect: '/NotFound'
	}
	]
})







// WEBPACK FOOTER //
// ./src/router/index.js